import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import BaseController from '../../BaseController';
import { FetchAPI } from '@philips-internal/oswald-ui-components';

@Controller({ component: 'layout-clinical-notes-description', fragment: 'clinical-notes-description' })
class NotaClinicaPacienteDescription extends BaseController {

  @Inject( 'fetch-clinical-notes-description' )
  fetch!: FetchAPI;

  @OnMount({ target: 'layout-clinical-notes-description' })
  onMount(): void {

    const { cdEvolucao } = this.historyService.getCurrentRouteParams();

    this.context.set({ cdEvolucao: cdEvolucao });
    this.fetch.forceFetch();

  }

}

export default NotaClinicaPacienteDescription;